<template>
  <div class="box d-flex flex-column">
    <div class="flex-grow-1 d-flex flex-column align-items-stretch">
      <div
        class="selector-container d-flex section-container"
        :class="{ dark: skinType }"
      >
        <SectionTitle title="告警列表"></SectionTitle>
        <project-level-selector
          @selectItem="selectItemListener"
          levelType="xm"
          style="margin-right: 1rem"
        ></project-level-selector>
        <el-form
          size="small"
          class="none-width flex-grow-1 d-flex align-items-stretch"
          :inline="true"
        >
          <el-form-item label="状态" :class="{ 'light-label': skinType }">
            <el-select v-model="selectState">
            <el-option
              v-for="(project, index) of workStageList"
              :key="'project-' + index"
              :label="project.label"
              :value="project.resId"
            ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="query-item"
            label="类型:"
            :class="{ 'light-label': skinType }"
          >
            <xia :treeData="alarmType" @receiveSelect="submitSelect"></xia>
          </el-form-item>
          <el-form-item
            class="query-item"
            label="时间:"
            :class="{ 'light-label': skinType }"
          >
            <el-date-picker
              type="date"
              placeholder="开始日期"
              v-model="startDate"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            class="query-item changew"
            label="至"
            :class="{ 'light-label': skinType }"
          >
            <el-date-picker
              v-model="endDate"
              type="date"
              placeholder="结束日期"
              class="widthchange"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item class="button-container">
            <el-button type="primary" @click="chaxun(0)">查询</el-button>
            <el-button @click="chaxun(1)">导出</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!--表格展示区域 -->
      <div
        style="overflow-y: auto"
        class="none-height flex-grow-1 section-container"
      >
        <el-table
          size="small"
          id="exportTable"
          stripe
          height="100%"
          ref="multipleTable"
          :data="tableData"
          highlight-current-row
          @row-click="GoworkOrderDetail"
          :class="{ dark: skinType }"
          :row-class-name="
            (...nu) => {
              return skinType ? 'dark text-white' : '';
            }
          "
        >
          <el-table-column type="index" label="#"></el-table-column>
          <el-table-column
            prop="EquipmentName"
            label="告警设备"
            min-width="150"
          >
          </el-table-column>
          <el-table-column prop="ProjectName" width="120" label="项目名称">
          </el-table-column>
          <el-table-column prop="State" label="告警状态" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.State | filterStatus }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="ReadStatusName" label="读取状态" width="80">
          </el-table-column>
          <el-table-column prop="RuleClassName" label="告警类型" width="190">
          </el-table-column>
          <el-table-column prop="StationName" label="所属站点">
          </el-table-column>
          <el-table-column prop="MarkTime" label="告警时间" width="160">
          </el-table-column>
          <el-table-column prop="Address" label="告警地点"> </el-table-column>
        </el-table>
        <div class="Alarmlist" v-if="showPrise">
          <el-button class="xbutton" @click="Alarmnone()">X</el-button>
          <el-table
          :data= "AlarmlistData"
          stripe
          :class="{ dark: skinType }"
          style="width: 100%"
          height="250"
          :row-class-name="
            (...nu) => {
              return skinType ? 'dark text-white' : '';
            }
          "
          >
            <el-table-column fixed prop="date" label="日期" width="150">
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="120">
            </el-table-column>
            <el-table-column prop="province" label="省份" width="120">
            </el-table-column>
            <el-table-column prop="city" label="市区" width="120">
            </el-table-column>
            <el-table-column prop="address" label="地址" width="300">
            </el-table-column>
            <el-table-column prop="zip" label="邮编" width="120">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 页数 -->
    <div
      v-if="pagetotal"
      style="
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 1rem;
      "
      class="section-container"
      :class="{ dark: skinType }"
    >
      <el-pagination
        style="margin-left: auto"
        :page-size="pageSize"
        background
        layout="total, prev, pager, next"
        :class="{ 'text-white': skinType }"
        :total="pagetotal"
        :current-page.sync="pageIndex"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/utils/section-title.vue';
import { exportExcel, formatDate } from '@/utils/utils';
import TurnAskingMixin from '@/mixins/turn-ask';
import ProjectLevelSelector from '@/components/utils/project-level-selector.vue';
import xia from '../utils/xia.vue';
import { getalarmList, getalarmtree, updatereadStatus } from '../../api/alarmList/alarmList';

export default {
  mixins: [TurnAskingMixin],
  components: {
    xia,
    SectionTitle,
    ProjectLevelSelector,
  },
  data() {
    return {
      selectProject: null,
      showPrise: false,
      AlarmlistData: [],
      tableData: [],
      startDate: formatDate(new Date(), 'yyyy-01-01'),
      endDate: formatDate(new Date(), 'yyyy-MM-dd'),
      // 总条数
      pagetotal: 0,
      // 一页多少条数据
      pageSize: 10,
      pageIndex: 1,
      // 工单阶段选项初始化值
      workStageList: [
        {
          resId: '',
          label: '请选择',
        },
        {
          resId: '0',
          label: '未处理',
        },
        {
          resId: '1',
          label: '处理中',
        },
        {
          resId: '2',
          label: '已处理',
        },
        {
          resId: '3',
          label: '已忽略',
        },
      ],
      // 告警类型存放值变量
      alarmType: [],
      // 所属项目
      subProject: null,
      selectState: '',
      // 故障类型
      faultType: null,
      // 告警类型
      orderPhase: null,
    };
  },
  created() {
    // 初始化查询条件
    getalarmtree()
      .then((res) => {
        this.alarmType = res.WarnGroupList;
        // this.projectList = res.ProjectList;
      })
      .catch((err) => {
        console.log(err);
      })
      .then(() => {
        this.requestWarnList();
      });
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
    projectList() {
	    return this.$store.getters.projectList;
    },
  },
  watch: {
    pageIndex() {
      this.requestWarnList();
    },
    selectProject() {
      this.requestWarnList();
    },
    selectState(val) {
      this.selectState = val;
	    this.requestWarnList();
    },
  },
  filters: {
    filterStatus(stateType) {
      let state = '';
      switch (stateType) {
        case 0:
          state = '未处理';
          break;
        case 1:
          state = '处理中';
          break;
        case 2:
          state = '已处理';
          break;
        case 3:
          state = '已忽略';
          break;
        default:
          break;
      }
      return state;
    },
  },
  methods: {
    selectItemListener(selectItem) {
      if (selectItem.oType === 'xm') {
        this.selectProject = selectItem;
      }
    },

    // 跳转告警详情
    getCurrentTime() {
      // 获取当前时间并打印
      const datatime = this;
      const yy = new Date().getFullYear();
      const mm = new Date().getMonth() + 1;
      const dd = new Date().getDate();
      const hh = new Date().getHours();
      const mf = new Date().getMinutes() < 10 ? `0${new Date().getMinutes()}` : new Date().getMinutes();
      const ss = new Date().getSeconds() < 10 ? `0${new Date().getSeconds()}` : new Date().getSeconds();
      datatime.gettime = `${yy}/${mm}/${dd} ${hh}:${mf}:${ss}`;
      return (datatime.gettime);
    },
    GoworkOrderDetail(rowindex) {
      const params = {
        WRID: rowindex.TABID,
      };
      updatereadStatus(params).then(() => {
      });
      console.log(rowindex);
      this.$router.push({
        path: 'realtime-monitoring/workorder-management',
        query: {
          id: rowindex.TABID,
        },
      });
    },
    // 修改table header的背景色
    // tableHeaderColor() {
    //   return 'color: #ffffff';
    // },
    // 子传父的值
    // 故障类型  返回id
    submitSelect(a) {
      if (a === '0') {
        this.faultType = '';
      } else {
        this.faultType = a;
      }
    },
    // 所属项目 全部传0
    sendSelectYezi(a, b) {
      let yezi = '';
      for (let i = 0; i < a.length; i += 1) {
        yezi = `${yezi + a[i].resId},`;
      }
      this.subProject = yezi.substring(0, yezi.length - 1);
      if (b === '') {
        this.subProject = '';
      }
    },
    // 告警类型  0.1.2.3
    sendSelectstate(a) {
      const c = [];
      const b = a.split(',');
      for (let i = 0; i < b.length; i += 1) {
        if (b[i] === 0) {
          this.orderPhase = '';
        } else {
          c.push(Number(b[i]) - 1);
        }
      }
      this.orderPhase = String(c);
      // console.log(this.orderPhase);
    },
    requestWarnList() {
      getalarmList({
        PageSize: this.pageSize,
        PageIndex: this.pageIndex,
        ProjectIdStr: this.selectProject ? this.selectProject.IdStr : '',
        WarnGroupID: this.faultType,
        State: this.selectState,
        StartTime: this.startDate,
        EndTime: this.endDate,
        IsExport: 0,
      })
        .then((res) => {
          if (res === null) {
            this.tableData = [];
            this.pagetotal = 0;
          } else {
            this.tableData = res.rows;
            this.pagetotal = res.records;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .then(() => {
        });
    },
    // 查询还是导出
    chaxun(f) {
      // 查询结果
      if (f === 0) {
        this.pageIndex = 1;
        this.requestWarnList();
      }
      // 导出结果
      if (f === 1) {
        this.pageSize = this.pagetotal;
        this.requestWarnList();
        setTimeout(() => {
        // Math.round(Math.random()*5
          exportExcel(this.$refs.multipleTable.$el, `告警列表-${this.getCurrentTime()}`);
        }, 1000);
        this.pageSize = 10;
      }
    },
    Alarmnone() {
      this.showPrise = false;
    },
    // 点击页数传入值进行获取工单列表 第pageNum的15条
    pageNow1() {
      this.requestWarnList();
    },
  },
};
</script>
<style lang="less" scoped>
.Alarmlist {
 // display: none;
  position: absolute;
  right: 0;
  bottom: 0;
  width: 500px;
  height: 18rem;
  z-index: 9999;
}
.el-select {
  width: 120px;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 120px;
}
/deep/.el-input--suffix .el-input__inner {
  padding-right: 0;
}

/deep/.el-input__inner {
  font-size: 0.8rem;
  color: #7c7c7c;
}
.box {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.el-table{
    color: #ffffff;
}
.xbutton{
  top: 0;
  right: 0;
  float: right;
}
</style>
